import { BaseProduct, ProductConfig } from "@utils/product/product-utils-types";
import { DateTimeUtils } from "@stellar/utils";
import { AllFeaturesTypes } from "@utils/product/product-types";
import { createProductsFromConfigs } from "@utils/product/product-utils";

const Feature: Record<AllFeaturesTypes, ProductConfig> = {
  ["global-face-blurring"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["ai-indexing"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["ft_spotwalk"]: {
    scopesWithoutLimit: ["PROJECT"],
    isCoreProduct: true,
    description: "Enables the use of the SpotWalk feature and app",
  },
  ["ft_download_360"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    description: "Enables the download of single 360 photos in the Web Editor",
  },
  ["ft_project_evaluation"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    description:
      "Enables the Project Evaluation feature in the Dashboard\nThe Company members needs to at least have a Project Manager or higher role",
  },
  ["project-progress"]: {
    scopesWithoutLimit: ["PROJECT"],
    isCoreProduct: true,
    description: "Access to Site Progress feature",
  },
  ["insights-teaser"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    description:
      "Unused: Shows a teaser for 'Project Progress' in the Dashboard, unless that feature is activated",
  },
  ["global-videomode"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
    description:
      "Grants access to the Video Mode feature. This includes the processing of videos on our infrastructure",
  },
  ["global-progress-ai"]: {
    scopesWithoutLimit: ["PROJECT"],
    description:
      "Unused: Enables Progress AI feature in the HoloBuilder Dashboard",
  },
  ["global-pointcloud-sendto"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["sphere-dashboard"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
  },
  photogrammetry: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["videomode-pointclouds"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["project-export"]: {
    scopesWithoutLimit: ["COMPANY"],
    duration: {
      defaultDays: DateTimeUtils.DURATION.days.inMonthApprox,
      isFixed: true,
    },
    isCoreProduct: true,
  },
  ["object-detection"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["focus-orbis-staging-area-workflows"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["sitescape-workflow"]: {
    scopesWithoutLimit: ["COMPANY", "PROJECT"],
    isCoreProduct: true,
  },
  ["core-product"]: {
    scopesWithoutLimit: ["COMPANY"],
    description:
      "Treats the company as one with a paid subscription. Automatically included in all Sphere XG Plans, Plan FM and Enterprise Features",
  },
};

/** List of all available features in Admin Panel */
export const allAvailableFeatures: Record<AllFeaturesTypes, BaseProduct> =
  createProductsFromConfigs(Feature);
